package com.shadowings.gero.data.lessons.chapter13

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_title_preposizione_dr
import gero.composeapp.generated.resources.exp_content_preposizione_dr_1
import gero.composeapp.generated.resources.exp_content_preposizione_dr_2
import gero.composeapp.generated.resources.exp_content_preposizione_dr_3
import gero.composeapp.generated.resources.exp_content_preposizione_dr_4
import gero.composeapp.generated.resources.exp_content_preposizione_dr_5
import gero.composeapp.generated.resources.exp_content_preposizione_dr_6
import gero.composeapp.generated.resources.exp_content_preposizione_dr_7
import gero.composeapp.generated.resources.exp_content_preposizione_dr_7_zeta
import gero.composeapp.generated.resources.exp_content_preposizione_dr_8
import gero.composeapp.generated.resources.exp_content_preposizione_dr_9
import gero.composeapp.generated.resources.exp_content_preposizione_dr_10
import gero.composeapp.generated.resources.exp_content_preposizione_dr_11
import gero.composeapp.generated.resources.exp_content_preposizione_dr_12
import gero.composeapp.generated.resources.quiz_preposizione_dr_1
import gero.composeapp.generated.resources.quiz_preposizione_dr_1_opt1
import gero.composeapp.generated.resources.quiz_preposizione_dr_1_opt2
import gero.composeapp.generated.resources.quiz_preposizione_dr_1_opt3
import gero.composeapp.generated.resources.quiz_preposizione_dr_1_opt4
import gero.composeapp.generated.resources.quiz_preposizione_dr_2
import gero.composeapp.generated.resources.quiz_preposizione_dr_2_opt1
import gero.composeapp.generated.resources.quiz_preposizione_dr_2_opt2
import gero.composeapp.generated.resources.quiz_preposizione_dr_2_opt3
import gero.composeapp.generated.resources.quiz_preposizione_dr_2_opt4
import gero.composeapp.generated.resources.quiz_preposizione_dr_3
import gero.composeapp.generated.resources.quiz_preposizione_dr_3_opt1
import gero.composeapp.generated.resources.quiz_preposizione_dr_3_opt2
import gero.composeapp.generated.resources.quiz_preposizione_dr_3_opt3
import gero.composeapp.generated.resources.quiz_preposizione_dr_3_opt4
import gero.composeapp.generated.resources.quiz_preposizione_dr_4
import gero.composeapp.generated.resources.quiz_preposizione_dr_4_opt1
import gero.composeapp.generated.resources.quiz_preposizione_dr_4_opt2
import gero.composeapp.generated.resources.quiz_preposizione_dr_4_opt3
import gero.composeapp.generated.resources.quiz_preposizione_dr_4_opt4
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import kotlin.random.Random

// MdC:
// 1. ḏr base: M36:D21 (flax bundle with phonetic complement r)
private const val DR_BASIC_GARDINER = "M36:D21"
// 2. ḏr rk Ḥrw: "since the age of Horus" (M36:D21 + D21:V31-N5 + G5)
private const val DR_RK_HRW_GARDINER = "M36:D21-D21:V31-N5-G5"

fun getPreposizioneDrContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_2,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_3,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = DR_BASIC_GARDINER, rtl = false, cart = false, size = 72.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_4,
            face = Faces.Surprised,
            character = Characters.Zeta,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "M36", rtl = false, cart = false, size = 72.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_5,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_6,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_7,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_7_zeta,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_8,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = DR_RK_HRW_GARDINER, rtl = false, cart = false, size = 56.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_9,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_10,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_11,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_dr,
            content = Res.string.exp_content_preposizione_dr_12,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getPreposizioneDrQuizContent(
    verbs: List<Verb> = DatabaseRepositoryImpl.verbs,
    words: List<Word> = DatabaseRepositoryImpl.words,
    languageCode: String = "it",
    random: Random = Random,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val specificQuizzes = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_dr_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_dr_1_opt1, correct = true),
                Option(Res.string.quiz_preposizione_dr_1_opt2, correct = false),
                Option(Res.string.quiz_preposizione_dr_1_opt3, correct = false),
                Option(Res.string.quiz_preposizione_dr_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_dr_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_dr_2_opt1, correct = true),
                Option(Res.string.quiz_preposizione_dr_2_opt2, correct = false),
                Option(Res.string.quiz_preposizione_dr_2_opt3, correct = false),
                Option(Res.string.quiz_preposizione_dr_2_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_dr_3,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_dr_3_opt1, correct = true),
                Option(Res.string.quiz_preposizione_dr_3_opt2, correct = false),
                Option(Res.string.quiz_preposizione_dr_3_opt3, correct = false),
                Option(Res.string.quiz_preposizione_dr_3_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_dr_4,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_dr_4_opt1, correct = true),
                Option(Res.string.quiz_preposizione_dr_4_opt2, correct = false),
                Option(Res.string.quiz_preposizione_dr_4_opt3, correct = false),
                Option(Res.string.quiz_preposizione_dr_4_opt4, correct = false)
            ).shuffled(random)
        )
    )

    val drSentenceQuizzes = buildDrComplementWordSelectionQuizzes(
        count = 6,
        random = random,
        languageCode = languageCode,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )

    return specificQuizzes + drSentenceQuizzes.shuffled(random)
}
